
// 1. 点击记录来源
document.addEventListener('click', function (e) {
  const el = e.target.closest('a');
  if (!el) return;

  const entry = el.dataset.entry || '';
  const currentUrl = entry ? window.location.pathname : ''
  sessionStorage.setItem('fabriqueEntry', entry);
  sessionStorage.setItem('fabriqueCurrentUrl', currentUrl);
});


function onBack() {
  sessionStorage.setItem('fabriqueEntry', '')
  sessionStorage.setItem('fabriqueCurrentUrl', '')
}

window.addEventListener('popstate', onBack);
window.addEventListener('pageshow', function (e) {
  if (e.persisted) onBack();
  try {
    const nav = performance.getEntriesByType('navigation')[0];
    if (nav && nav.type === 'back_forward') onBack();
  } catch (err) { }
});


function getFeatureValue(feature, defaultValue, timeout = 3000) {
  return new Promise((resolve) => {
    const start = Date.now();
    let timer = null;

    const check = () => {
      try {
        const value = window._growthbook?.getFeatureValue?.(feature, defaultValue);
        if (value !== undefined && value !== null) {
          resolve(value);
          return;
        }
      } catch (err) {
        // 忽略异常
      }

      if (Date.now() - start < timeout) {
        timer = setTimeout(check, 100);
      } else {
        resolve(defaultValue);
      }
    };

    check();
  });
}

function getLightboxAnchorForImage(img) {
  if (!img) return null;

  return (
    img.closest?.('a.product__gallery-toggle[data-pswp-image]') ||
    img.closest?.('[data-media-id]')?.querySelector?.('a.product__gallery-toggle[data-pswp-image]') ||
    img.closest?.('[data-ab-slide-kind="image"]')?.querySelector?.('a.product__gallery-toggle[data-pswp-image]') ||
    null
  );
}

function syncLightboxAnchorForImage(img, imageUrl) {
  const anchor = getLightboxAnchorForImage(img);
  if (!anchor || !imageUrl) return;

  anchor.setAttribute('href', imageUrl);
  anchor.setAttribute('data-pswp-src', imageUrl);

  if (anchor.hasAttribute('data-pswp-srcset')) {
    anchor.setAttribute('data-pswp-srcset', img?.getAttribute('srcset') || '');
  }
}

function normalizeVariantValue(variant) {
  return String(variant || '').trim();
}

function isControlVariant(variant) {
  return normalizeVariantValue(variant) === '1';
}

async function handleABImg(img) {
  if (!img || img.__abHandled) return;
  if (img?.getAttribute('data-img-type') === '1') return;
  if (img.closest?.('[data-ab-slide-order]')) {
    img.__abHandled = true;
    return;
  }
  img.__abHandled = true;
  const raw = img.getAttribute('data_ai_img_src');
  let aiImgs = [];
  try {
    aiImgs = JSON.parse(raw);
  } catch (e) {
    aiImgs = [];
  }
  if (!Array.isArray(aiImgs) || aiImgs.length === 0) return;

  const productId = img.getAttribute('data-product-id');
  if (!productId) return;

  const featureKey = img.getAttribute('data_ai_img_feature_id');
  let variant = '1';

  try {
    variant = await getFeatureValue(featureKey, '1', 2000);
  } catch (e) { }
  const normalizedVariant = normalizeVariantValue(variant);

  const wrapper =
    img.closest('.fabrique-product-wrapper, .quick-cart-product, .cart-item') ||
    document.querySelector(`.fabrique-product-abTestBox-${productId}`);
  const input = document.querySelector('input[data-good-id]');
  if (input && input.value === productId) {
    input.setAttribute('data-ab-variant', normalizedVariant);
  }

  wrapper?.setAttribute('data-ab-variant', normalizedVariant);
  img.setAttribute('data-ab-variant', normalizedVariant);

  if (isControlVariant(normalizedVariant)) return;

  const variantNum = Number(normalizedVariant);
  if (!Number.isInteger(variantNum) || variantNum < 1) return;

  const imgIndex = variantNum - 1;
  const expImage = aiImgs[imgIndex];
  if (!expImage) return;
  /* ------------------ 替换图片 ------------------ */
  img.src = expImage + "?x-oss-process=image/format,webp/quality,Q_80/resize,w_1000";
  if (img.hasAttribute('srcset')) {
    img.setAttribute(
      'srcset',
      expImage + "?x-oss-process=image/format,webp/quality,Q_80/resize,w_1000"
    );
  }
  syncLightboxAnchorForImage(img, expImage);

}

(function () {
  if (!document.querySelectorAll) return;
  const IMG_SELECTOR = 'img.fabrique-product-image-abtest';
  const SLIDE_CONTAINER_SELECTOR = '[data-ab-slide-order]';

  function normalizeImageUrl(url) {
    if (!url) return '';

    try {
      const parsedUrl = new URL(url, window.location.origin);
      return `${parsedUrl.origin}${parsedUrl.pathname}`;
    } catch (err) {
      return String(url).split('#')[0].split('?')[0];
    }
  }

  function parseSlideOrder(container) {
    const raw = container?.dataset?.abSlideOrder;
    if (!raw) return [];

    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (err) {
      return [];
    }
  }

  function rememberOriginalImage(img) {
    if (!img) return null;

    if (!img.dataset.abOriginalSrc) {
      img.dataset.abOriginalSrc = img.currentSrc || img.getAttribute('src') || '';
    }

    if (!img.dataset.abOriginalSrcset && img.hasAttribute('srcset')) {
      img.dataset.abOriginalSrcset = img.getAttribute('srcset') || '';
    }

    return img;
  }

  function applyImageSource(img, nextSrc) {
    if (!img || !nextSrc) return;

    rememberOriginalImage(img);

    img.setAttribute('src', nextSrc);

    if (img.hasAttribute('srcset')) {
      img.setAttribute('srcset', nextSrc);
    }
  }

  function getOriginalImageData(img) {
    if (!img) return null;

    rememberOriginalImage(img);
    return {
      src: img.dataset.abOriginalSrc || img.getAttribute('src') || '',
      srcset: img.dataset.abOriginalSrcset || img.getAttribute('srcset') || '',
      width: img.getAttribute('width') || '',
      height: img.getAttribute('height') || '',
      alt: img.getAttribute('alt') || '',
    };
  }

  function applyImageData(img, imageData) {
    if (!img || !imageData?.src) return;

    rememberOriginalImage(img);
    img.setAttribute('src', imageData.src);

    if (imageData.srcset) {
      img.setAttribute('srcset', imageData.srcset);
    } else if (img.hasAttribute('srcset')) {
      img.removeAttribute('srcset');
    }

    if (imageData.width) {
      img.setAttribute('width', imageData.width);
    }

    if (imageData.height) {
      img.setAttribute('height', imageData.height);
    }

    if (imageData.alt !== undefined) {
      img.setAttribute('alt', imageData.alt);
    }
  }

  function rememberOriginalAnchor(anchor) {
    if (!anchor) return null;

    if (!anchor.dataset.abOriginalHref) {
      anchor.dataset.abOriginalHref = anchor.getAttribute('href') || '';
    }

    if (!anchor.dataset.abOriginalPswpSrc) {
      anchor.dataset.abOriginalPswpSrc = anchor.getAttribute('data-pswp-src') || '';
    }

    if (!anchor.dataset.abOriginalPswpSrcset) {
      anchor.dataset.abOriginalPswpSrcset = anchor.getAttribute('data-pswp-srcset') || '';
    }

    if (!anchor.dataset.abOriginalPswpWidth) {
      anchor.dataset.abOriginalPswpWidth = anchor.getAttribute('data-pswp-width') || '';
    }

    if (!anchor.dataset.abOriginalPswpHeight) {
      anchor.dataset.abOriginalPswpHeight = anchor.getAttribute('data-pswp-height') || '';
    }

    return anchor;
  }

  function getSlideImageAnchor(img) {
    const slide = img?.closest?.('[data-ab-slide-kind="image"]');
    if (!slide) return img?.closest?.('a.product__gallery-toggle[data-pswp-image]') || null;

    return (
      slide.querySelector('a.product__gallery-toggle[data-pswp-image]') ||
      img.closest?.('a.product__gallery-toggle[data-pswp-image]') ||
      null
    );
  }

  function getOriginalAnchorData(anchor) {
    if (!anchor) return null;

    rememberOriginalAnchor(anchor);
    return {
      href: anchor.dataset.abOriginalHref || '',
      pswpSrc: anchor.dataset.abOriginalPswpSrc || '',
      pswpSrcset: anchor.dataset.abOriginalPswpSrcset || '',
      pswpWidth: anchor.dataset.abOriginalPswpWidth || '',
      pswpHeight: anchor.dataset.abOriginalPswpHeight || '',
    };
  }

  function applyAnchorData(anchor, anchorData) {
    if (!anchor || !anchorData) return;

    rememberOriginalAnchor(anchor);

    if (anchorData.href) {
      anchor.setAttribute('href', anchorData.href);
    }

    if (anchorData.pswpSrc) {
      anchor.setAttribute('data-pswp-src', anchorData.pswpSrc);
    }

    if (anchorData.pswpSrcset) {
      anchor.setAttribute('data-pswp-srcset', anchorData.pswpSrcset);
    } else if (anchor.hasAttribute('data-pswp-srcset')) {
      anchor.setAttribute('data-pswp-srcset', '');
    }

    if (anchorData.pswpWidth) {
      anchor.setAttribute('data-pswp-width', anchorData.pswpWidth);
    }

    if (anchorData.pswpHeight) {
      anchor.setAttribute('data-pswp-height', anchorData.pswpHeight);
    }
  }

  function getOriginalSlideData(img) {
    return {
      image: getOriginalImageData(img),
      anchor: getOriginalAnchorData(getSlideImageAnchor(img)),
    };
  }

  function applySlideData(img, slideData) {
    if (!img || !slideData?.image) return;

    applyImageData(img, slideData.image);
    applyAnchorData(getSlideImageAnchor(img), slideData.anchor);
  }

  function getFallbackMainImage(container) {
    if (!container) return null;

    if (container.matches?.('product-card')) {
      return (
        container.querySelector('.product-card__media img:not(.hover-img):not(.hidden)') ||
        container.querySelector('.product-card__media img:not(.hover-img)')
      );
    }

    if (container.matches?.('.cart-item')) {
      return container.querySelector('.cart-item__media img');
    }

    return container.querySelector(IMG_SELECTOR) || container.querySelector('img');
  }

  function collectImageSlots(container) {
    const slideItems = Array.from(
      container.querySelectorAll('[data-ab-slide-kind="image"]')
    );
    if (slideItems.length > 0) {
      return slideItems
        .map(slide => rememberOriginalImage(slide.querySelector('img')))
        .filter(Boolean);
    }

    const mainImg = getFallbackMainImage(container);

    if (!mainImg || mainImg.getAttribute('data-img-type') === '1') {
      return [];
    }

    return [rememberOriginalImage(mainImg)];
  }

  function updateCardHover(container, variantConfig) {
    if (!container?.matches?.('product-card')) return;

    const mainImg = getFallbackMainImage(container);
    const hoverImg = container.querySelector('img.hover-img');
    const originalFirstSrc = container.dataset.originalFirstImgSrc || '';
    const originalHoverSrc = container.dataset.originalHoverImgSrc || '';

    if (!mainImg || !hoverImg || !originalFirstSrc || !originalHoverSrc) return;

    const imageIndex = Number(variantConfig?.imageIndex);
    const nextHoverSrc =
      !isControlVariant(variantConfig?.group) && imageIndex === 1
        ? originalFirstSrc
        : originalHoverSrc;

    applyImageSource(hoverImg, nextHoverSrc);
  }

  function getOriginalImageSource(img) {
    if (!img) return '';
    rememberOriginalImage(img);
    return img.dataset.abOriginalSrc || img.currentSrc || img.getAttribute('src') || '';
  }

  function resolveTargetOriginalIndex(imageSlots, variantConfig) {
    const imageIndex = Number(variantConfig?.imageIndex);

    if (Number.isInteger(imageIndex) && imageIndex >= 0) {
      if (imageIndex < imageSlots.length) {
        return imageIndex;
      }
    }

    const targetUrl = variantConfig?.imageUrl;
    if (!targetUrl) return -1;

    const normalizedTargetUrl = normalizeImageUrl(targetUrl);
    return imageSlots.findIndex(img => {
      return normalizeImageUrl(getOriginalImageSource(img)) === normalizedTargetUrl;
    });
  }

  function buildSlideSwappedImageData(imageSlots, variantConfig) {
    if (!Array.isArray(imageSlots) || imageSlots.length === 0) return [];

    const originalImages = imageSlots.map(getOriginalSlideData).filter(item => item?.image?.src);
    const targetIndex = resolveTargetOriginalIndex(imageSlots, variantConfig);

    if (targetIndex < 0) return [];
    if (targetIndex === 0) return originalImages;

    const swappedImages = [...originalImages];
    const firstImage = swappedImages[0];

    swappedImages[0] = swappedImages[targetIndex];
    swappedImages[targetIndex] = firstImage;

    return swappedImages;
  }

  function isSingleImageContainer(container) {
    if (!container) return false;
    return container.matches?.('product-card, .cart-item');
  }

  async function handleSlideOrder(container) {
    if (!container || container.dataset.abSlideInitialized === 'true') return;

    const slideOrder = parseSlideOrder(container);
    if (!slideOrder.length) {
      container.dataset.abSlideInitialized = 'true';
      return;
    }

    const featureKey = container.dataset.abSlideFeatureId || '';
    if (!featureKey) {
      container.dataset.abSlideInitialized = 'true';
      return;
    }

    let variant = '1';
    try {
      variant = await getFeatureValue(featureKey, '1', 2000);
    } catch (err) {}
    const normalizedVariant = normalizeVariantValue(variant);
    container.dataset.abVariant = normalizedVariant;

    const imageSlots = collectImageSlots(container);
    imageSlots.forEach(img => {
      img.setAttribute('data-ab-variant', normalizedVariant);
    });

    const variantConfig = slideOrder.find(item => {
      return (
        String(item?.group) === normalizedVariant &&
        (
          Number.isInteger(Number(item?.imageIndex)) ||
          Boolean(item?.imageUrl)
        )
      );
    });
    if (!imageSlots.length) {
      container.dataset.abSlideInitialized = 'true';
      return;
    }

    if (isSingleImageContainer(container) && container.matches?.('product-card')) {
      updateCardHover(container, variantConfig);
    }

    if (isControlVariant(normalizedVariant)) {
      container.dataset.abSlideInitialized = 'true';
      return;
    }

    if (!variantConfig) {
      container.dataset.abSlideInitialized = 'true';
      return;
    }

    if (isSingleImageContainer(container)) {
      const mainImg = imageSlots[0];
      const nextSrc = variantConfig?.imageUrl;

      if (mainImg && nextSrc) {
        applyImageSource(mainImg, nextSrc);
      }

      updateCardHover(container, variantConfig);

      container.dataset.abSlideInitialized = 'true';
      return;
    }

    const swappedImages = buildSlideSwappedImageData(imageSlots, variantConfig);
    if (!swappedImages.length) {
      container.dataset.abSlideInitialized = 'true';
      return;
    }

    imageSlots.forEach((img, index) => {
      const nextImage = swappedImages[index];
      if (!nextImage?.image?.src) return;

      applySlideData(img, nextImage);
    });

    container.dataset.abSlideInitialized = 'true';
  }

  function scan(root = document) {
    if (root === document) {
      document.querySelectorAll(IMG_SELECTOR).forEach(handleABImg);
      document.querySelectorAll(SLIDE_CONTAINER_SELECTOR).forEach(handleSlideOrder);
      return;
    }

    if (!(root instanceof HTMLElement)) return;

    if (root.matches(IMG_SELECTOR)) {
      handleABImg(root);
    } else {
      root.querySelectorAll?.(IMG_SELECTOR).forEach(handleABImg);
    }

    if (root.matches(SLIDE_CONTAINER_SELECTOR)) {
      handleSlideOrder(root);
    } else {
      root.querySelectorAll?.(SLIDE_CONTAINER_SELECTOR).forEach(handleSlideOrder);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan(document));
  } else {
    scan(document);
  }
  const observer = new MutationObserver(mutations => {
    for (const m of mutations) {
      if (m.type === 'childList') {
        m.addedNodes.forEach(node => {
          scan(node);
        });
      }
      if (
        m.type === 'attributes' &&
        m.attributeName === 'src' &&
        m.target.matches?.(IMG_SELECTOR)
      ) {
        handleABImg(m.target);
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['src']
  });

  window.__fabriqueABRefresh = () => scan(document);
})();
